<template>
    <section class="py-20 px-4">
      <div class="max-w-3xl mx-auto text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4">Perguntas Frequentes</h2>
      </div>
  
      <div class="max-w-3xl mx-auto divide-y divide-gray-200">
        <div
          v-for="(faq, index) in faqs"
          :key="index"
          class="py-4"
        >
          <button
            @click="toggle(index)"
            class="w-full flex justify-between items-center text-left focus:outline-none"
          >
            <span
              :class="[
                'text-base md:text-lg font-medium transition',
                activeIndex === index ? 'text-pink-500' : 'text-gray-900'
              ]"
            >
              {{ faq.pergunta }}
            </span>
            <span
            :class="[
                'text-xl font-bold transition-transform duration-200',
                'inline-block transform',
                activeIndex === index ? 'rotate-45 text-pink-500' : 'rotate-0 text-black'
            ]"
            >
            +
            </span>
          </button>
  
          <div
            v-if="activeIndex === index"
            class="mt-2 text-sm text-gray-500"
          >
            {{ faq.resposta }}
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  const activeIndex = ref(0)
  
  const toggle = (index) => {
    activeIndex.value = activeIndex.value === index ? null : index
  }
  
  const faqs = [
    {
      pergunta: 'A Integrator Host tem servidores localizados no Brasil?',
      resposta: 'Não, todos nossos servidores estão localizado no Canadá e EUA.',
    },
    {
      pergunta: 'O suporte é 24 horas?',
      resposta: 'Sim, oferecemos suporte via ticket 24/7/365 e atendimento pelo WhatsApp em horário comercial.',
    },
    {
      pergunta: 'Meus dados estão protegidos',
      resposta: 'Sim, seguimos a Lei de Proteção de Dados LGPD.',
    },
    {
      pergunta: 'Quais são as forma de pagamento',
      resposta: 'Trabalhamos com PIX, Paypal e Boleto Bancário.',
    },
    {
      pergunta: 'Tem fidelização na assinatura?',
      resposta: 'Não! Você pode cancelar quando quiser, sem taxas de fidelidade.',
    },
    {
      pergunta: 'A Integrator Host permite envio de SPAM?',
      resposta: 'Não, qualquer envio de SPAM a sua conta será suspensa.',
    },
  ]
  </script>
  